<script setup>
import { useAbility } from '@casl/vue'

definePage({
  meta: {
    layout: 'default',
    action: 'view-own',
    subject: 'Task',
  },
})

const ability = useAbility()
const scope = ref('mine')
</script>

<template>
  <div>
    <VRow class="mb-4">
      <VCol cols="12">
        <div class="d-flex align-center justify-space-between flex-wrap gap-3">
          <div>
            <h4 class="text-h4 font-weight-bold">
              Task
            </h4>
            <p class="text-body-2 text-medium-emphasis mb-0">
              Pekerjaan berbasis PIC & tenggat waktu (§10.8)
            </p>
          </div>
          <VBtnToggle
            v-if="ability.can('view-all', 'Task')"
            v-model="scope"
            density="compact"
            color="primary"
            mandatory
          >
            <VBtn value="mine">
              Task Saya
            </VBtn>
            <VBtn value="all">
              Task Semua
            </VBtn>
          </VBtnToggle>
        </div>
      </VCol>
    </VRow>

    <VCard>
      <VCardText>
        <TaskList :scope="scope" />
      </VCardText>
    </VCard>
  </div>
</template>
